import { createContext } from 'react'
import { IScriptContext } from '../interfaces'

export const StoreFrontScriptManagerContext = createContext<IScriptContext>({
  scriptList: [],
  isLoading: false,
  isOperationLoading: false,
  filters: {
    search: '',
    page: 1,
    limit: 30,
    sortBy: 'updated_at',
    sortDirection: 'desc'
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0
  },
  deleteScript: async () => {},
  onSearch: () => {},
  onPageChange: () => {},
  onSortingChange: () => {},
  hasWritePermission: false,
})
